<template>
  <Layout header-class="header-left-align " nav-alignment="left">
    <HeroUtopia />

    <div class="home-services-intro">
      <SectionTwo :userLogin="userLogin" />
      <SectionTitle
        id="section3"
        class="mt-5 pt--100"
        text-align="center"
        :subtitle="$t('SectionThree.subtitle')"
        :title="$t('SectionThree.title')"
        description=""
        data-aos="fade-up"
      />
    </div>

    <ServicesSticky />

    <TargetAudience />

    <div class="rn-service-area rn-section-gap">
      <div class="container" id="section5">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle2
              id="sec5"
              class="pros-cons-heading"
              :subtitle="$t('Home.let_summarize_subtitle')"
              text-align="center"
              :title="$t('Home.pros_cons_title')"
              data-aos="fade-up"
              description=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container" :class="{ '': userLogin, '': !userLogin }">
      <div class="rn-service-area">
        <Servicepros card-style="card-style-1" text-align="left" style="padding-bottom: 10%" />
      </div>
    </div>

    <div class="rn-section-gap ht-flip-section">
      <div class="container">
        <ServiceFlipCarousel />
      </div>
    </div>

    <div
      :class="{
        'background-sec-6-lightmode': userLogin,
        'background-sec-6-lightmode': !userLogin
      }"
    >
      <div class="rwt-split-area" id="section6">
        <div class="wrapper">
          <Split
            class=""
            style="padding-top: 2%"
            id="sec6"
            :split-data="splitsection5Data"
            :split-style="4"
          />
        </div>
      </div>
    </div>

    <SignageReveal />

    <div class="rwt-brand-area rn-section-gapBottom">
      <div
        class=""
        :class="{
          'background-concern mask-bottom-fade': !userLogin,
          'background-concern-light mask-tb-fade': userLogin
        }"
        style="padding-bottom: 10%"
      >
        <div class="container pt-lg-5">
          <div class="row">
            <div class="col-lg-12 mt-lg-5">
              <SectionTitle
                id="section7"
                text-align="center"
                :subtitle="$t('Home.few_steps_ahead_subtitle')"
                :title="$t('Home.meet_our_customers_title')"
                data-aos="fade-up"
              />
            </div>
          </div>
          <div class="row mt-5">
            <Brand
              class="mt-3 justify-content-center"
              :brand-list="brandList"
              :brandlistlight="brandListlight"
              :brand-style="4"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="rwt-timeline-area" id="section8">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
              id="sec8"
              text-align="center"
              :subtitle="$t('Home.few_steps_ahead_subtitle')"
              :title="$t('Home.how_to_get_connected_title')"
              :description="$t('Home.support_teams_desc')"
            />
          </div>
        </div>
        <div class="row mt_dec--20">
          <div class="col-lg-12">
            <Timeline
              :timeline-data="timelineData"
              :button-text="$t('Home.get_started_now')"
              :show-button="false"
            />
          </div>
        </div>
      </div>
    </div>

    <Separator />

    <div
      class="mt--200"
      id="section9"
      :class="{
        'background-sec-10 mask-tb-fade': userLogin === false,
        'background-sec-10-light mask-tb-fade': userLogin === true
      }"
    >
      <div class="rn-company-mission-are rn-section-gap">
        <div class="container">
          <div class="row row--30 justify-content-center">
            <div class="col-12 text-center mb--40" id="sec9">
              <div class="mission-title">
                <h2 class="title" data-aos="fade-up">
                  {{ $t('Home.how_can_we_help') }}<br />
                  <vue-typed-js
                    :key="$i18n.locale"
                    class="theme-gradient justify-content-center"
                    :strings="[
                      $t('Home.faq_typed.one'),
                      $t('Home.faq_typed.two'),
                      $t('Home.faq_typed.three'),
                      $t('Home.faq_typed.four')
                    ]"
                    :loop="true"
                    :type-speed="80"
                    :start-delay="1000"
                    :back-speed="50"
                  >
                    <b class="is-visible typing"></b>
                  </vue-typed-js>
                </h2>
              </div>
            </div>
            <div class="col-12 col-lg-10 col-xl-8">
              <Accordion
                id="accordionExampleOne"
                data-aos="fade-up"
                data-aos-delay="60"
                :accordion-content="faqData"
                accordion-style-class="faq-cards"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <Separator />
  </Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import Separator from '../../components/elements/separator/Separator'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import Accordion from '../../components/elements/accordion/Accordion'
import Split from '../../components/elements/split/Split'
import SignageReveal from '../../components/Home/SignageReveal'
import Brand from '../../components/elements/brand/Brand'
import Timeline from '../../components/elements/timeline/Timeline'
import SectionTitle2 from '../../components/elements/sectionTitle/SectionTitle2.vue'
import '@/assets/global.css'
import i18n from '../../../i18n/i18n'
import Servicepros from '../../components/elements/service/Servicepros'
import ServicesSticky from '../../components/Home/ServicesSticky'
import TargetAudience from '../../components/Home/TargetAudience'
import SectionTwo from '../../components/Home/SectionTwo'
import HeroUtopia from '../../components/Home/HeroUtopia'
import ServiceFlipCarousel from '../../components/Home/ServiceFlipCarousel'

export default {
  name: 'Homepage',
  i18n,
  props: ['dataFromParent'],
  components: {
    ServiceFlipCarousel,
    Accordion,
    Timeline,
    Brand,
    Split,
    SectionTitle,
    Separator,
    SignageReveal,
    Layout,
    SectionTitle2,
    Servicepros,
    ServicesSticky,
    TargetAudience,
    SectionTwo,
    HeroUtopia
  },
  data() {
    return {
      brandList: [
        {
          image: require(`@/assets/images/logo/pumpcharge-logo-white.png`)
        }
      ],
      brandListlight: [
        {
          image: require(`../../assets/images/logo/pumpcharge-logo-blue.png`)
        }
      ]
    }
  },
  computed: {
    userLogin() {
      return this.$store.state.userLogin
    },
    splitsection5Data() {
      return {
        image: 'Group_27923.svg',
        image1: 'Group 28074@2x.png',
        title: this.$t('SectionFiveData.title'),
        description: this.$t('SectionFiveData.description'),
        counterData1: [
          {
            number: 252,
            title: this.$t('SectionFiveData.connected_cpos')
          },
          {
            number: 189,
            title: this.$t('SectionFiveData.connected_emsps')
          }
        ],
        counterData2: [
          {
            number: 184,
            title: this.$t('SectionFiveData.charging_stations')
          },
          {
            number: 184,
            title: this.$t('SectionFiveData.charging_connectors')
          }
        ]
      }
    },
    timelineData() {
      const translations = this.$t('SectionTimeline')
      const images = [
        'tobias-reich-sC5ZgFyGB4Y-unsplash.png',
        'Discussion.png',
        'Implementation.png'
      ]
      return translations.map((item, index) => ({
        id: (index + 1).toString(),
        date: this.$t('Home.step') + ' ' + (index + 1),
        title: item.title,
        description: item.description,
        image: images[index],
        workingStep: item.workingStep
      }))
    },
    faqData() {
      const translations = this.$t('FAQ')
      const ids = ['One', 'Two', 'Three', 'Four']
      return translations.map((item, index) => ({
        id: ids[index],
        title: item.title,
        description: item.description
      }))
    }
  },
  methods: {
    scrollToService() {
      const { view, scrollTo } = this.$route.query
      const storeScrollTarget = this.$store.state.scrollTarget
      const targetId = scrollTo || storeScrollTarget

      if (targetId) {
        this.$nextTick(async () => {
          const element = document.getElementById(targetId)
          if (element) {
            const precedingImages = Array.from(document.images).filter(
              (image) => image.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING
            )
            await Promise.all(precedingImages.map((image) => image.decode().catch(() => {})))
            if (!element.isConnected) return
            element.scrollIntoView({ behavior: 'smooth' })
          }

          if (storeScrollTarget) {
            this.$store.commit('setScrollTarget', null)
          }
          if (scrollTo) {
            this.$router
              .replace({
                path: this.$route.path,
                query: { ...this.$route.query, scrollTo: undefined }
              })
              .catch(() => {})
          }
        })
      } else if (view === 'service' || view === 'Concerned') {
        const id = view === 'service' ? 'service-compoments' : 'Concerned-Parties'
        this.$nextTick(() => {
          const element = document.getElementById(id)
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
          }

          this.$router
            .replace({ path: this.$route.path, query: { ...this.$route.query, view: undefined } })
            .catch(() => {})
        })
      }
    }
  },

  mounted() {
    this.scrollToService()
  },
  watch: {
    $route() {
      this.scrollToService()
    }
  }
}
</script>

<style>
.path-layout {
  transform: translate(209px, -14px);
  position: absolute;
  width: 74vw;
  /* z-index: 1; */
}

.path-layout-1 {
  transform: translate(0px, 55px);
  /* position: absolute; */
  /* z-index: 1; */
}

.sizesection7 {
  height: 100vh;
  width: 100%;
}

.section7-layout {
  margin-top: 25%;
}

.background-sec-5-1-lightmode,
.background-sec-6-lightmode,
.background-sec-9-lightmode {
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.background-sec-5-1-lightmode::before,
.background-sec-6-lightmode::before,
.background-sec-9-lightmode::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: -1;
}

.background-sec-5-1-lightmode::before {
  background-image: url(../../assets/images/Newlandindpage/lightmode/Group_sec-5.png);
  background-position: -0% 70%;
}

.background-sec-6-lightmode::before {
  background-image: url(../../assets/images/Newlandindpage/lightmode/Group_6.png);
  background-position: -0% 70%;
}

.background-sec-9-lightmode::before {
  background-image: url(../../assets/images/Newlandindpage/lightmode/Group_9.png);
  background-position: -0% 70%;
}

.background-sec-4,
.background-sec-4-light,
.background-sec-10,
.background-sec-10-light {
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.background-sec-4::before,
.background-sec-4-light::before,
.background-sec-10::before,
.background-sec-10-light::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: -1;
}

.background-sec-4::before {
  background-image: url(../../assets/images/Newlandindpage/Rectangle\ 10301.svg);
  background-position: -0% 50%;
}

.background-sec-4-light::before {
  background-image: url(../../assets/images/Newlandindpage/lightmode/Group_28005@2x.png);
  background-position: -0% 50%;
}

.background-sec-10::before {
  background-image: url(../../assets/images/Newlandindpage/Rectangle\ 10119.svg);
  background-position: -0% 50%;
}

.background-sec-10-light::before {
  background-image: url(../../assets/images/Newlandindpage/lightmode/sec-10.png);
  background-position: -0% 100%;
}

.sizeimage {
  width: 80%;
  padding: 10%;
}

.background-concern,
.background-concern-light,
.backgroundpros,
.background-sec-3-1-lightmode,
.background-sec-3-2-lightmode {
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.background-concern::before,
.background-concern-light::before,
.backgroundpros::before,
.background-sec-3-1-lightmode::before,
.background-sec-3-2-lightmode::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: -1;
}

.background-concern::before {
  background-image: url(../../assets/images/Newlandindpage/bg-concern.png);
  background-position: -0% 0%;
}

.background-concern-light::before {
  background-image: url(../../assets/images/Newlandindpage/lightmode/Group_28005@2x.png);
  background-position: -0% 0%;
}

.backgroundpros::before {
  background-image: url(../../assets/images/Newlandindpage/testbg.png);
  background-position: center;
}

.background-sec-3-1-lightmode::before {
  background-image: url(../../assets/images/Newlandindpage/lightmode/Group_sec3-1.png);
  background-position: center;
}

.background-sec-3-2-lightmode::before {
  background-image: url(../../assets/images/Newlandindpage/lightmode/Group_3_2.png);
  background-position: center;
}

.background-sec-1,
.background-sec-1-lightmode {
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.background-sec-1::before,
.background-sec-1-lightmode::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: -1;
}

.background-sec-1::before {
  background-image: url(../../assets/images/Newlandindpage/newimage/Group-bg-sec1.png);
  background-position: center;
}

.background-sec-1-lightmode::before {
  background-image: url(../../assets/images/Newlandindpage/newimage/Group\ 33591.png);
  background-position: -0% 0%;
}

.mask-top-fade::before {
  -webkit-mask-image: linear-gradient(to top, black 80%, transparent 100%) !important;
  mask-image: linear-gradient(to top, black 80%, transparent 100%) !important;
}

.mask-bottom-fade::before {
  -webkit-mask-image: linear-gradient(to bottom, black 80%, transparent 100%) !important;
  mask-image: linear-gradient(to bottom, black 80%, transparent 100%) !important;
}

.mask-tb-fade::before {
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    black 20%,
    black 80%,
    transparent 100%
  ) !important;
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    black 20%,
    black 80%,
    transparent 100%
  ) !important;
}

.mask-left-fade {
  -webkit-mask-image: linear-gradient(
    to left,
    transparent 0%,
    black 20%,
    black 80%,
    transparent 100%
  );
  mask-image: linear-gradient(to left, transparent 0%, black 20%, black 80%, transparent 100%);
}

.mask-right-fade {
  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 20%,
    black 80%,
    transparent 100%
  ) !important;
  mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 20%,
    black 80%,
    transparent 100%
  ) !important;
}

.hidebutton {
  transform: translate(81.8%, -2950%);
  position: fixed;
  bottom: 10%;
  right: 0%;
  z-index: 9999;
  width: 100%;
}

.ggth {
  background: -moz-linear-gradient(45deg, #8a32a5 0%, #afb3b5 29%, #d0a2d4 66%, #ffa079 100%);
  background: -webkit-linear-gradient(45deg, #8a32a5 0%, #afb3b5 29%, #d0a2d4 66%, #ffa079 100%);
  background: linear-gradient(45deg, #8a32a5 0%, #afb3b5 29%, #d0a2d4 66%, #ffa079 100%);
  background-size: 400% 400%;
  -webkit-animation: Gradient 15s ease infinite;
  -moz-animation: Gradient 15s ease infinite;
  animation: Gradient 15s ease infinite;
  /*min-height: calc(100vh - 2rem);*/
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-evenly;
  overflow: hidden;
  position: relative;
}

.ggth::before,
.ggth::after {
  content: '';
  width: 70vmax;
  height: 70vmax;
  position: absolute;
  background: rgba(255, 255, 255, 0.07);
  left: -20vmin;
  top: -20vmin;
  animation: morph 15s linear infinite alternate, spin 20s linear infinite;
  z-index: 1;
  will-change: border-radius, transform;
  transform-origin: 55% 55%;
  pointer-events: none;
}

.ggth::after {
  width: 70vmin;
  height: 70vmin;
  left: auto;
  right: -10vmin;
  top: auto;
  bottom: 0;
  animation: morph 10s linear infinite alternate, spin 26s linear infinite reverse;
  transform-origin: 20% 20%;
}

@-webkit-keyframes Gradient {
  0% {
    background-position: 0 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

@-moz-keyframes Gradient {
  0% {
    background-position: 0 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

@keyframes Gradient {
  0% {
    background-position: 0 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

@keyframes morph {
  0% {
    border-radius: 40% 60% 60% 40% / 70% 30% 70% 30%;
  }

  100% {
    border-radius: 40% 60%;
  }
}

@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}

.rotate-bg-y {
  transform: scaleY(-1);
}

.rotate-bg-x {
  transform: scaleX(-1);
}

.rotate-bg-180 {
  transform: rotate(180deg);
}

.rotate-bg-90 {
  transform: rotate(90deg);
}

.rotate-bg-270 {
  transform: rotate(270deg);
}

.rotate-bg-spin {
  animation: spin 10s linear infinite;
}

.st0 {
  display: none;
}

.st1 {
  display: inline;
}

.st2 {
  opacity: 0.29;
}

.st3 {
  fill: #ffffff;
}

.st4 {
  clip-path: url(#SVGID_2_);
  fill: #ffffff;
}

.st5 {
  clip-path: url(#SVGID_4_);
}

.st6 {
  clip-path: url(#SVGID_6_);
}

.st7 {
  clip-path: url(#SVGID_8_);
}

.st8 {
  clip-path: url(#SVGID_10_);
}

.st9 {
  fill: none;
}

.st10 {
  clip-path: url(#SVGID_12_);
}

.st11 {
  opacity: 0.7;
}

.st12 {
  clip-path: url(#SVGID_14_);
}

.st13 {
  opacity: 0.2;
}

.st14 {
  clip-path: url(#SVGID_16_);
}

.st15 {
  opacity: 0.3;
  fill: #ffffff;
  enable-background: new;
}

.light-icon {
  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
}

.light-icon:hover {
  transform: scale(1.05) translateY(-5px);
}

h3 {
  font-size: 20px;
  font-family: var(--secondary-font);
  font-weight: bold;
  color: #fff;
}

.svg-icon {
  width: 48px;
  height: 48px;
  background-color: currentColor;
  -webkit-mask-image: var(--svg-url);
  mask-image: var(--svg-url);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  display: inline-block;
}

@media only screen and (max-width: 991px) {
  #section4 .section-title {
    text-align: center !important;
  }
}
</style>
